import React from 'react';
import { useSelector } from 'react-redux';
import { RootState as C_RootState } from '@Redux/common/store';
import cN from 'classnames';
import { PreviewBlock } from '@lion-design/core';
import SubTitle from '@components/DetailPage/SubTitle';
import styles from './styles.module.scss';

interface I_Props {
    texts: {
        main: string;
        sub: string;
    };
    children: React.ReactNode;
    scrollEleId?: string;
    scrollOffset?: number;
}

const ItineraryNoticesFrame: React.FC<I_Props> = ({
    texts,
    children,
    scrollEleId,
    scrollOffset,
}) => {
    const { curPage } = useSelector((store: C_RootState) => store.pageReducer);
    return (
        <div className={cN(styles.container, 'itinerary_notices_frame')}>
            <SubTitle texts={texts} />
            <PreviewBlock
                actionHeight={162}
                className={cN(styles.content, { [`${styles.printMode}`]: curPage === 'print' })}
                scrollEleId={scrollEleId}
                scrollOffset={scrollOffset}
            >
                {children}
            </PreviewBlock>
        </div>
    );
};

export default ItineraryNoticesFrame;
